import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "selectize"; // ensures $.fn.selectize (when jQuery is present) or window.Selectize is available

export default class extends Controller {
  connect() {
    this.init();
  }

  init() {
    const investeeEl = document.querySelector('select[name$="[investee_id]"]');

    const offersEl = this.element;
    if (!investeeEl || !offersEl) return;

    // Initialize Selectize if missing
    const investeeSelectize = this.ensureSelectize(investeeEl);
    const offersSelectize = this.ensureSelectize(offersEl, { maxItems: null });

    if (!investeeSelectize || !offersSelectize) {
      // Library not ready yet — try again shortly
      setTimeout(() => this.init(), 60);
      return;
    }

    investeeSelectize.addOption({ value: "", text: "Select an investee" });
    const form = investeeEl.closest("form");
    const isNewRecord =
      form && !form.querySelector('input[name="_method"][value="patch"]');

    if (isNewRecord) {
      // For a new record, always default to the blank option
      investeeSelectize.setValue("", true);
    } else {
      // For an edit record, if there's no value, also set to blank
      if (!investeeSelectize.getValue()) {
        investeeSelectize.setValue("", true);
      }
    }
    // Initial state for offers
    const currentInvesteeId = investeeSelectize.getValue();
    if (!currentInvesteeId || currentInvesteeId <= 0) {
      offersSelectize.disable();
    } else {
      this.fetchAndPopulateOffers(currentInvesteeId, offersSelectize);
    }

    // Re-bind safely (avoid duplicate listeners)
    investeeSelectize.off("change");
    investeeSelectize.on("change", (value) => {
      this.handleInvesteeChange(value, offersSelectize);
    });
  }

  ensureSelectize(el, options = {}) {
    // Already initialized
    if (el.selectize) return el.selectize;

    if ($.fn && $.fn.selectize) {
      try {
        $(el).selectize(options);
        return el.selectize;
      } catch (e) {
        console.warn("Selectize jQuery init failed:", e);
        return null;
      }
    }

    // Fallback if needed (though the import above should handle it)
    if (window.Selectize) {
      try {
        return new window.Selectize(el, options);
      } catch (e) {
        console.warn("Selectize vanilla init failed:", e);
        return null;
      }
    }

    console.warn("Selectize library not loaded yet");
    return null;
  }

  handleInvesteeChange(investeeId, offersSelectize) {
    offersSelectize.clear();
    offersSelectize.clearOptions();

    if (investeeId && investeeId > 0) {
      offersSelectize.enable();
      this.fetchAndPopulateOffers(investeeId, offersSelectize, true);
    } else {
      offersSelectize.disable();
    }
  }

  async fetchAndPopulateOffers(
    investeeId,
    offersSelectize,
    selectItems = false
  ) {
    const url = `/backoffice/investees/${investeeId}/offers`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      const options = data.map((item) => ({ value: item[0], text: item[1] }));

      offersSelectize.clearOptions();
      offersSelectize.addOption(options);

      if (selectItems) {
        const itemValues = options.map((op) => op.value);
        offersSelectize.addItems(itemValues);
      }

      offersSelectize.refreshOptions();
    } catch (error) {
      console.error("Failed to fetch offers:", error);
    }
  }
}
